import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import isRequired from '../../../decorators/isRequired.decorator';
import { BaseComponent } from '../../base.component';
import { fromPromise } from 'rxjs/internal/observable/innerFrom';

@Component({
    selector: 'ui-base-camera',
    templateUrl: './base-camera.component.html',
    styleUrls: ['./base-camera.component.less'],
})
export class BaseCameraComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() width: number = 640;
    @Input() height: number = 480;

    @ViewChild('video') video: ElementRef;

    @isRequired()
    @Input()
    takePhotoBtn: HTMLButtonElement;

    @Output() onPhotoTaken: EventEmitter<string> = new EventEmitter();

    isError: boolean = false;
    canvas: HTMLCanvasElement;
    mediaStream: MediaStream;

    constructor(private renderer: Renderer2) {
        super();
    }

    ngOnInit(): void {
        this.canvas = this.renderer.createElement('canvas');
        this.renderer.setAttribute(this.canvas, 'width', this.width + 'px');
        this.renderer.setAttribute(this.canvas, 'height', this.height + 'px');
    }

    ngAfterViewInit(): void {
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            const userMedia$ = fromPromise(navigator.mediaDevices.getUserMedia({ audio: false, video: { facingMode: 'user' } }));
            this.subs = userMedia$.subscribe(
                (mediaStream: MediaStream) => {
                    if (!mediaStream) {
                        this.isError = true;
                        return;
                    }
                    this.video.nativeElement.srcObject = mediaStream;
                    this.mediaStream = mediaStream;
                    this.video.nativeElement.play();
                    if (this.takePhotoBtn) {
                        this.renderer.listen(this.takePhotoBtn, 'click', this.takePhoto.bind(this));
                    }
                },
                (e) => {
                    this.isError = true;
                    this.renderer.addClass(this.takePhotoBtn, 'disabled');
                }
            );
        }
    }

    takePhoto(): void {
        if (!this.video) {
            return;
        }
        this.canvas.getContext('2d').drawImage(this.video.nativeElement, 0, 0, this.width, this.height);
        this.onPhotoTaken.emit(this.canvas.toDataURL('image/jpg'));
    }

    private stopMediaTracks(): void {
        if (this.mediaStream && this.mediaStream.getTracks) {
            this.mediaStream.getTracks().forEach((track: MediaStreamTrack) => track.stop());
        }
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
        this.stopMediaTracks();
    }
}
